export enum LoadingState {
  Initial, // nothing happened yet. to be started
  Loading, // loading was started and still going on
  Failed, // loading content failed
  Loaded // successfully loaded content
}
